/* @jsxImportSource react */

import * as React from 'react';
import { cn } from '../../utils/cn/cn';

export type DividerProps = Omit<React.HtmlHTMLAttributes<HTMLHRElement>, 'children'> & {
  orientation?: 'horizontal' | 'vertical';
  flexItem?: boolean;
};

/**
 * Thin horizontal/vertical divider
 */
const Divider = ({ className, flexItem = false, orientation = 'horizontal' }: DividerProps) => (
  <hr
    className={cn(
      `border-color-separator border-solid ${flexItem ? 'h-auto self-stretch' : 'h-full'} ${orientation === 'vertical' ? 'm-0 shrink-0 border-r-[thin]' : 'border-b-[thin] border-l-0 border-r-0 border-t-0'}`,
      className,
    )}
  />
);

Divider.displayName = 'Divider';

export { Divider };
